import React from "react";
import { Helmet } from "react-helmet";

export const PowerBiLossAnalysisView = (props) => {
  return (
    <>
      <div>Hi</div>
      <Helmet>
        <link href={require("./powerbi-loss-analysis.scss").default} />
      </Helmet>
    </>
  );
};
